import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Preventivo, DatiAnagrafici, PreventivoResponseDTO, VocePolizza } from '../shared/preventivo';
import { PrefissiInternazionali } from '../shared/prefissi-internazionali';

import { BackendApi } from '../shared/backend-api';
import { catchError, EMPTY, take, timeout } from 'rxjs';

@Component({
  selector: 'app-step3',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './step3.html',
  styleUrl: './step3.css'
})

export class Step3 {
  @Output() avanti = new EventEmitter<void>();

  ragioneSociale = '';
  nome = '';
  cognome = '';
  email = '';
  prefisso = '+39';
  telefono = '';

  privacyConsenso = false;
  marketingConsenso = false;

  prefissiInternazionali: { flag: string, value: string }[] = [];

  isLoading = false;
  errore: string | null = null;

  preventivo: PreventivoResponseDTO | null = null;
  massimale: number | null = null;
  voci: VocePolizza[] = [];

  constructor(
    private api: BackendApi,
    private preventivoService: Preventivo,
    private prefissiService: PrefissiInternazionali
  )
  {
    this.voci = this.preventivoService.getVoci() || [];
    this.massimale = this.preventivoService.getMassimale();
    this.preventivo = null;
    this.prefissiInternazionali = this.prefissiService.getPrefissi();

    // WarmUp "fire-and-forget" per svegliare la function
    this.api.warmUp().pipe(take(1), timeout(25000), catchError(() => EMPTY)).subscribe();
  }

  richiediPreventivo() {
    if (!this.nome || !this.cognome || !this.email || !this.ragioneSociale) {
      alert('Compila tutti i campi obbligatori');
      return;
    }

    this.isLoading = true;
    this.errore = null;

    const anagrafica: DatiAnagrafici = {
      ragioneSociale: this.ragioneSociale,
      nome: this.nome,
      cognome: this.cognome,
      email: this.email,
      prefisso: this.prefisso,
      telefono: this.telefono
    };

    this.preventivoService.setDatiAnagrafici(anagrafica);
    this.preventivoService.setPrivacyConsenso(this.privacyConsenso);
    this.preventivoService.setMarketingConsenso(this.marketingConsenso);

    const body = {
      referralCode: this.preventivoService.getReferral() ?? null,
      massimale: this.massimale,
      voci: this.voci,
      questionario: this.preventivoService.getQuestionario(),
      datiAnagrafici: anagrafica,
      privacyConsenso: this.privacyConsenso,
      marketingConsenso: this.marketingConsenso
    };

    this.api.creaPreventivo(body).subscribe({
        next: (res) => {
          this.preventivo = res;
          this.preventivoService.setPreventivo(res);
          this.isLoading = false;
        },
        error: (err) => {
          //console.error('Errore durante la richiesta:', err);
          this.errore = 'Errore durante la richiesta del preventivo. Riprovare più tardi';
          this.isLoading = false;
        }
      });
  }

  avantiStep() {
    this.avanti.emit();
  }

  isAnagraficaValida(): boolean {
    const telefonoValido = !this.telefono || /^[0-9]{6,10}$/.test(this.telefono);
    const emailValida = !!this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);

    return !!this.ragioneSociale &&
          !!this.nome &&
          !!this.cognome &&
          !!this.email &&
          telefonoValido &&
          emailValida &&
          this.privacyConsenso;
  }
}
